import request from "@/api/index";

export function getNews(listType) {
    return request({
        url: "/news/list",
        method: "get",
        params: { listType }
    })
}

export function getDoxs() {
    return request({
        url: "/file/list",
        method: "get"
    })
}

export function getProducts(query) {
    return request({
        url: "/product/list",
        method: "get",
        params: query
    })
}

export function getProductInfo(id) {
    return request({
        url: "/product/info",
        method: "get",
        params: { id }
    })
}



// WEBPACK FOOTER //
// ./src/api/api.js